export default __webpack_public_path__ + "static/media/category_04.fe93581d.png";